import React, { Component } from "react"

/* Cuba go ep-ui */
import { Background, Balance, Internet, GameInfo, Transactions, Error } from "@cuba-go/ep-ui"

/* Components */
import { Payout, Picture, Timer, Double, Hit, Stand, Split, Surrender, Notification } from "./components"

/* Widgets */
import { Chips, Preloader, Rates, PlayerCards, DealerCards } from "./widgets"

/* Socket IO */
import { io } from "socket.io-client"

/* JWT */
import { decodeToken } from 'react-jwt'

import { Howl } from 'howler'

/* REST API */
import { history } from './api/History'

/* Constants */
import { env, utils, sound } from "./constants"
import { ERROR, CHOICE, DEALING, GAME, INSURANCE, LOADING, WAITING } from "./constants/status"

/* Rules */
import { rules } from "./constants/rules"

/* Redux */
import { connect } from 'react-redux'

import History from "./widgets/History"

const backgroundSound = new Howl({
    src: [`https://testing-cb.makaobet.com/electronic/sounds/newbg.mp3`],
    volume: 0.4,
    mute: false,
    loop: true,
    html5: true,
    format: ["mp3"],
    onplayerror: () => {
        backgroundSound.once('unlock', () => {
            backgroundSound.play()
        })
    },
    onend: () => {
        backgroundSound.play()
    }
})

let hidden = null
let visibilityChange = null
if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden'
    visibilityChange = 'visibilitychange'
}
else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
    visibilityChange = 'msvisibilitychange'
}
else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
}

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""

const tempBoxStake = { ante: 0, perfectpair: 0, twentyone: 0, crazyseven: 0, bust: 0 }
const tempStakes = [{ ...tempBoxStake }, { ...tempBoxStake }, { ...tempBoxStake }, { ...tempBoxStake }, { ...tempBoxStake }]

const imgUrl = 'https://repb.rekopgames.com/images/rules/game.png'


/* Entry Point */
class App extends Component {

    constructor() {
        super()

        const data = decodeToken(token)

        this.state = {
            status: LOADING,
            boxPlayers: [null, null, null, null, null],

            showTimer: false,
            innerTimeShow: true,
            currentTime: 0,

            selected: 0,
            stakes: [...tempStakes],
            last: [...tempStakes],
            list: [],
            balance: 0,
            total: 0,
            lastWin: 0,

            playerCards: [[], [], [], [], []],
            dealerCards: [],

            boxStand: [0, 0, 0, 0, 0],
            boxGames: [null, null, null, null, null],
            blackjack: [false, false, false, false],

            split: false,
            surrender: false,

            dealerGame: null,

            gameBox: null,
            playerBox: null,

            solution: "",

            result: [null, null, null, null, null],
            ppResult: [null, null, null, null, null],
            twentyoneResult: [null, null, null, null, null],
            crazySevenResult: [null, null, null, null, null],
            bustResult: [null, null, null, null, null],

            /* GENERAL */

            gameInfo: null,
            transactions: [],
            operations: [],
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,

            showInternetConnectionError: 0,

            /* Game Session */
            closed: false,
            newDevice: false,
            isDisconnected: false,

            currency: data.currency,
            chips: utils.getChips(data.chips),
            game: {
                max: data.max,
                min: data.min,
                maxPay: data.maxPay,
                maxPerfectPair: data.maxPerfectPair,
                maxTwentyOne: data.maxTwentyOne,
                maxBust: data.maxBust,
                maxCrazySeven: data.maxCrazySeven
            },

            volume: false,
            locale: data.locale ? data.locale : "ru",
            isDemo: data.isDemo,
            operator: data.operator,

            playerId: data.playerId,
            isPlayed: false,
        }

        /* Start connection */
        this.socket = io(env.endpoint, { auth: { token: `${token}`, reconnection: false, isPlayer: true } })
        this.timerInterval = null
    }

    componentDidMount = () => {

        const { locale } = this.state
        const { setLanguage } = this.props
        setLanguage(locale)

        this.game()
        this.loadHistory()

        document.addEventListener(visibilityChange, this.handleVisibilityChange)
    }

    componentWillUnmount() {
        document.removeEventListener(visibilityChange, this.handleVisibilityChange)
    }


    handleVisibilityChange = () => {
        // console.log(document[hidden], Date.now() % 10000)
        // console.log('current - ', this.state.currentTime)
        if (document[hidden]) {
            this.setState({ innerTimeShow: false })
        } else {
            if (this.state.currentTime > 1) {
                this.setState({ showTimer: true })
            }
            setTimeout(() => {
                this.setState({ innerTimeShow: true })
            }, 250)
        }
    }


    /* Load History */
    loadHistory = (page = 1) => {

        const { histories } = this.state

        if (page > 1) {
            this.setState({ historyPage: page })
        }

        history(token, page).then(response => {
            if (response.status === 200) {
                let list = response.data
                // console.log(list[0])

                if (page > 1) {
                    list = [...histories, ...response.data]
                }

                if (response.data.length < 5) {
                    this.setState({ historyHasMore: false })
                }

                this.setState({ histories: list, historyLoading: false })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false })
        })
    }

    game = () => {
        /* On error */
        this.socket.on("connect_error", () => {

            const timer = setTimeout(() => {
                this.setState({ status: ERROR })
                clearTimeout(timer)

                if (backgroundSound) {
                    backgroundSound.volume(0)
                    backgroundSound.stop()
                }
            }, 1000)

        })

        /*  */
        this.socket.on("disconnect", () => {
            this.setState({ isDisconnected: true })
            if (backgroundSound) {
                backgroundSound.volume(0)
                backgroundSound.stop()
            }
        })


        /* isRemoved */
        this.socket.on("setInactionState", () => {
            this.setInactionState()
            this.updateTimer()
        })

        /* On connect */
        this.socket.on("connect", () => {
        })

        /* On New Device */
        this.socket.on("newDeviceConnection", () => {
            this.setState({ newDevice: true })
            this.socket.disconnect()
            if (backgroundSound) {
                backgroundSound.volume(0)
                backgroundSound.stop()
            }
        })


        /* Player join box */
        this.socket.on("boxJoin", data => {
            const { playerData, box } = data
            const { boxPlayers } = this.state
            boxPlayers[box] = playerData
            this.setState({ boxPlayers })
        })

        this.socket.on("boxLeft", box => {
            const { boxPlayers, stakes, playerId, total } = this.state
            const boxTotal = stakes[box].ante + stakes[box].perfectpair + stakes[box].twentyone + stakes[box].bust + stakes[box].crazyseven
            if (boxPlayers[box] && boxPlayers[box].playerId === playerId && stakes[box]) {
                this.setState({ total: total - boxTotal })
            }
            boxPlayers[box] = null
            stakes[box] = { ...tempBoxStake }
            this.setState({ boxPlayers, stakes })
        })

        this.socket.on("boxPlayers", data => {
            this.setState({ boxPlayers: data })
        })

        this.socket.on("playerBoxStake", data => {
            const { stake, index } = data
            const { stakes } = this.state
            let tempStakes = [...stakes]
            tempStakes[index] = stake
            this.setState({ stakes: tempStakes })
        })

        this.socket.on("playersStake", data => {
            this.setState({ stakes: data })
        })

        this.socket.on("afterSplit", data => {
            const { playerCards, boxGames } = this.state
            const { box, game, cards } = data
            playerCards[box] = cards
            boxGames[box] = game
            this.setState({ playerCards, boxGames })
        })

        this.socket.on("messageToPlayer", ({ type }) => {
            const text = type === "autostand" ? "Auto stand" : type === "transaction" ? "Transaction error" : "Insurance lost"
            const toggleType = type === "autostand" ? "info" : "error"
            utils.toggleError(text, toggleType)
            this.setState({ status: WAITING, showTimer: false })
            if (type === "autostand") {
                this.updateTimer()
            }
        })


        /* Reconnection */
        this.socket.on("reconnection", data => {

            console.log(data)

            const time = data.transactionError ? 3000 : 1500

            if (data.transactionError) {
                utils.toggleError(utils.translate("Transaction error"))
            }

            if (data.error) {
                utils.toggleError(utils.translate("System error"))
            }

            this.setState({
                boxPlayers: data.boxPlayers,
                stakes: data.stakes ? data.stakes : [...tempStakes],
                playerCards: data.boxCards,
                dealerCards: data.dealerCards,
                boxGames: data.boxGames,
                dealerGame: data.dealerGame,
                gameInfo: data.gameInfo,
                total: data.total,
                gameBox: data.gameBox,
                boxStand: data.boxStand,
                split: data.split,
                surrender: data.surrender,
                result: data.result,
                ppResult: data.ppResult,
                twentyoneResult: data.twentyoneResult,
                crazySevenResult: data.crazySevenResult,
                bustResult: data.bustResult,
                transactions: data.transactions
            })

            setTimeout(() => {
                this.setState({
                    status: data.status,
                    showTimer: data.timer ? true : false,
                    currentTime: data.timer,
                })
                if (data.timer) {
                    this.checkTimer(data.timer)
                }
            }, time)
        })

        /* On start */
        this.socket.on("status", data => {
            const { status, timer, split, surrender } = data
            if (status !== this.state.status) {
                this.setState({ status })
            }

            if (timer && !this.state.currentTime) {
                this.setState({ showTimer: true, currentTime: timer })
                this.checkTimer(timer)
            }

            if (status === GAME) {
                this.setState({ split, surrender, solution: "", })
            }


        })

        /* Clear Game */
        this.socket.on("clearGame", () => {
            this.clear()
            this.loadHistory()
        })


        /* Hide Timer */
        this.socket.on("hideTimer", () => {
            this.setState({ showTimer: false, currentTime: 0 })
            this.updateTimer()
        })

        /* Balance */
        this.socket.on("balance", data => {
            this.setState({ balance: data })
        })

        /* Game box */
        this.socket.on("gameBox", data => {
            this.setState({
                gameBox: data.box,
                playerBox: (data.playerBox === 0 || data.playerBox === 1) ? data.playerBox : null
            })
        })

        /* Box stand */
        this.socket.on("boxStand", data => {
            this.setState({ boxStand: data })
        })

        /* Get a dealer card */
        this.socket.on("dealer", data => {

            const { card } = data

            const { dealerCards, volume } = this.state
            const i = dealerCards.findIndex(e => e.uuid === card.uuid)
            let cards = dealerCards

            if (i === -1) {
                cards.push(card)
                this.setState({ dealerCards: cards })

                if (volume) {
                    sound.play('card', 0.2)
                }
            }

        })

        this.socket.on("dealerData", data => {
            const { dealerCards, dealerGame, dealerBJ } = data
            this.setState({ dealerCards, dealerBJ })
            setTimeout(() => {
                this.setState({ dealerGame })
            }, 1000)
        })

        this.socket.on("dealerGame", data => {
            setTimeout(() => {
                this.setState({ dealerGame: data })
            }, 500)
        })

        /* Get a Player card */
        this.socket.on("card", data => {

            const { playerCards, dealerCards, volume } = this.state

            const { card, box } = data

            if (box !== 'dealer') {

                let tempPlayerCards = playerCards[box]

                const boxCards = data.playerBox !== null ? tempPlayerCards && tempPlayerCards[data.playerBox] && Array.isArray(tempPlayerCards[data.playerBox]) ? tempPlayerCards[data.playerBox] : [] : tempPlayerCards ? tempPlayerCards : []
                const i = boxCards.findIndex(e => e.uuid === card.uuid)
                if (i === -1) {
                    let cards = boxCards
                    cards.push(card)
                    if (data.playerBox !== null) {
                        tempPlayerCards[data.playerBox] = cards

                    } else {
                        tempPlayerCards = cards
                    }
                    let tempAllBoxCards = playerCards
                    tempAllBoxCards[box] = tempPlayerCards
                    this.setState({ playerCards: tempAllBoxCards, playerBox: (data.playerBox === 0 || data.playerBox === 1) ? data.playerBox : null })

                    if (volume) {
                        sound.play('card', 0.2)
                    }
                }
            } else {
                const i = dealerCards.findIndex(e => e.uuid === card.uuid)
                let cards = dealerCards

                if (i === -1) {
                    cards.push(card)
                    this.setState({ dealerCards: cards })

                    if (volume) {
                        sound.play('card', 0.2)
                    }
                }
            }

        })

        /* PLAYER CARDS ARRAY AND GAME AFTER SPLIT */
        this.socket.on("playerData", data => {

            const { playerCards, playerGame } = data

            if (playerCards && Array.isArray(playerCards)) {
                this.setState({ playerCards, playerGame, gameBox: 0 })
            }
        })

        this.socket.on("playerGame", data => {

            const { boxGames, ppResult, twentyoneResult } = this.state
            const { box, game, playerBox, blackjack } = data

            if (playerBox === 0 || playerBox === 1) {
                boxGames[box][playerBox] = game
            } else {
                boxGames[box] = game
            }

            this.setState({ boxGames })

            if (blackjack) {
                let tempBlackjack = this.state.blackjack
                tempBlackjack[box] = blackjack
                setTimeout(() => {
                    this.setState({ blackjack: tempBlackjack })
                }, 500)
            }

            setTimeout(() => {
                if (data.ppResult) {
                    ppResult[box] = data.ppResult
                    this.setState({ ppResult })
                }
                if (data.twentyoneResult) {
                    twentyoneResult[box] = data.twentyoneResult
                    this.setState({ twentyoneResult })
                }
            }, 700)
        })

        /* Crazy seven result */
        this.socket.on("crazySevenResult", data => {
            const { ind, sevenResult } = data
            const { crazySevenResult } = this.state
            crazySevenResult[ind] = sevenResult
            this.setState({ crazySevenResult })
        })

        /* Bust result */
        this.socket.on("bustResult", data => {
            this.setState({ bustResult: data })
        })


        /* Result */
        this.socket.on("results", results => {

            const { volume, stakes } = this.state

            if (results && Array.isArray(results)) {
                results.forEach((result, index) => {
                    if (result && result.ante) {
                        stakes[index].ante = result.ante
                    }
                })
            }

            this.setState({ stakes, result: results })

            // if (result && result.text === "win") {
            //     this.setState({ lastWin: result.sum })
            // }

            // setTimeout(() => {
            //     this.setState({ result })
            //     if (result && (result.text === "win" || result.text === "draw")) {
            //         if (volume) {
            //             sound.play('win', 0.2)
            //         }
            //     }
            // }, 1000)

        })

        /* Get Game Info */
        this.socket.on("gameInfo", data => {
            this.setState({ gameInfo: data })
        })

        /* Get transactions list */
        this.socket.on("transaction", data => {
            if (data.id) {
                const { operations } = this.state

                operations.push(data)
                this.setState({ operations })

            }
        })

        this.socket.on("editTransaction", data => {
            const { operations } = this.state
            let list = operations
            const index = list.findIndex(e => e.number === data.number)
            if (index > -1) {
                list[index].status = data.status
                this.setState({ operations: list })
            }
        })


        /* Force End Game */
        this.socket.on("forceEnd", () => {
            this.setState({ status: CHOICE })
            this.loadHistory()
            this.clear()
            utils.toggleError(utils.translate("The game ended due to the administrator's initiative"), "warning")
        })

        /* Notification From Admin */
        this.socket.on("adminNotification", data => {
            if (data && data.title && data.total && data.currency) {
                utils.toggleError(`${utils.translate(data.title)} ${utils.getWithCurrency(data.total, data.currency)}`, "success")
                this.loadHistory()
            }
        })

    }

    /* Disconnect user when inaction timer equal to 0 */
    setInactionState = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }

    /* Reser top timing */
    updateTimer = () => {
        clearInterval(this.timerInterval)
        this.timerInterval = null
        this.setState({ currentTime: 0 })
    }

    handleClose = (id) => {

        const { showInternetConnectionError } = this.state

        if (id === "internet" && showInternetConnectionError <= 2) {
            this.setState({ showInternetConnectionError: showInternetConnectionError + 1 })
            if (showInternetConnectionError + 1 === 2) {
                setTimeout(() => {
                    this.setState({ showInternetConnectionError: 1 })
                }, 300000)
            }
        }

    }

    /* Check internet speed */
    checkInternetSpeed = (speed) => {

        const { showInternetConnectionError } = this.state

        if (showInternetConnectionError < 2) {
            if (parseInt(speed) < 3) {
                utils.toggleError(utils.translate("Poor internet connection"), "warning", "internet", this.handleClose)
            }
            else {
                utils.toastDismiss('internet')
            }
        }

    }

    checkTimer = (timer) => {

        if (timer && timer > 1) {
            let tempCurrentTime = timer

            this.timerInterval = setInterval(() => {
                tempCurrentTime -= 1
                this.setState({ currentTime: tempCurrentTime })
                console.log(tempCurrentTime && tempCurrentTime > 0 && tempCurrentTime < 5)
                if (tempCurrentTime && tempCurrentTime > 0 && tempCurrentTime < 5) {
                    console.log(tempCurrentTime)
                    sound.play('tic', 0.5)
                }
                if (tempCurrentTime === 0 || tempCurrentTime < 0) {
                    this.setState({ showTimer: false, status: WAITING })
                    this.updateTimer()
                }
            }, 1000)
        }

    }

    clear = () => {
        this.setState({
            showTimer: false,
            currentTime: 0,

            selected: 0,
            stakes: [...tempStakes],
            list: [],
            total: 0,
            lastWin: 0,

            playerCards: [[], [], [], [], []],
            dealerCards: [],

            boxStand: [0, 0, 0, 0, 0],
            boxGames: [null, null, null, null, null],
            blackjack: [false, false, false, false],

            split: false,
            surrender: false,

            dealerGame: null,

            gameBox: null,
            playerBox: null,

            solution: "",

            result: [null, null, null, null, null],
            ppResult: [null, null, null, null, null],
            twentyoneResult: [null, null, null, null, null],
            crazySevenResult: [null, null, null, null, null],
            bustResult: [null, null, null, null, null],

            transactions: []
        })
    }


    boxJoin = box => {
        this.socket.emit("join", box)
    }

    boxLeft = box => {
        this.socket.emit("left", box)
    }


    setStakes = (data) => {

        const { playerId, boxPlayers, stakes, list } = this.state

        let tempPlayerStakes = [...stakes]
        let toBackStakes = []

        let total = 0

        let tempList = list

        data && Array.isArray(data) && data.forEach((stake, index) => {
            if (boxPlayers && boxPlayers[index] && boxPlayers[index].playerId === playerId && stake) {
                total += stake.ante + stake.perfectpair + stake.twentyone + stake.bust + stake.crazyseven

                tempPlayerStakes[index] = { ...data[index] }
                toBackStakes[index] = { ...data[index] }

                if (!stake.ante) {
                    tempList = tempList.filter(e => e.place !== `ante-${index}`)
                }
                if (!stake.perfectpair) {
                    tempList = tempList.filter(e => e.place !== `perfectpair-${index}`)
                }
                if (!stake.twentyone) {
                    tempList = tempList.filter(e => e.place !== `twentyone-${index}`)
                }
                if (!stake.crazyseven) {
                    tempList = tempList.filter(e => e.place !== `crazyseven-${index}`)
                }
                if (!stake.bust) {
                    tempList = tempList.filter(e => e.place !== `bust-${index}`)
                }
            }
        })

        this.setState({ stakes: [...tempPlayerStakes], last: [...tempPlayerStakes], total, lastWin: 0, list: tempList })
        this.socket.emit("stakes", toBackStakes)
    }


    /* Game action */
    gameAction = (action) => {
        this.socket.emit("gameAction", action)
    }

    /* DOUBLE */
    double = () => {

        const { status, gameBox, boxPlayers, playerId, solution, volume } = this.state

        if (status === GAME && gameBox !== null && boxPlayers && boxPlayers[gameBox] && boxPlayers[gameBox].playerId === playerId && solution !== "HIT" && solution !== "STAND" && solution !== "SURRENDER") {

            this.socket.emit("double", gameBox)

            this.setState({ solution: "STAND", status: WAITING, split: false, surrender: false, showTimer: false })

            if (volume) {
                sound.play('sound', 0.2)
            }

        }

        this.updateTimer()

    }

    /* HIT */
    hit = () => {

        const { status, gameBox, boxPlayers, playerId, solution, volume } = this.state

        if (status === GAME && gameBox !== null && boxPlayers && boxPlayers[gameBox] && boxPlayers[gameBox].playerId === playerId && solution !== "HIT" && solution !== "STAND" && solution !== "SURRENDER") {

            this.socket.emit("hit", gameBox)

            this.setState({ solution: "HIT", status: WAITING, split: false, surrender: false, showTimer: false })

            if (volume) {
                sound.play('sound', 0.2)
            }

        }

        this.updateTimer()

    }

    /* STAND */
    stand = () => {

        const { status, gameBox, boxPlayers, playerId, solution, volume } = this.state

        if (status === GAME && gameBox !== null && boxPlayers && boxPlayers[gameBox] && boxPlayers[gameBox].playerId === playerId && solution !== "HIT" && solution !== "STAND" && solution !== "SURRENDER") {

            this.socket.emit("stand", gameBox)

            this.setState({ solution: "STAND", status: WAITING, split: false, surrender: false, showTimer: false })

            if (volume) {
                sound.play('sound', 0.2)
            }

        }

        this.updateTimer()

    }


    /* SURRENDER */
    surrender = () => {

        const { status, gameBox, boxPlayers, playerId, solution, volume } = this.state

        if (status === GAME && gameBox !== null && boxPlayers && boxPlayers[gameBox] && boxPlayers[gameBox].playerId === playerId && solution !== "HIT" && solution !== "STAND" && solution !== "SURRENDER") {

            this.socket.emit("surrender", gameBox)

            this.setState({ solution: "SURRENDER", status: WAITING, split: false, surrender: false, showTimer: false })

            if (volume) {
                sound.play('sound', 0.2)
            }

        }

        this.updateTimer()

    }

    /* SPLIT */
    split = () => {

        const { status, stakes, gameBox, boxPlayers, playerId, boxStand, solution, volume, balance } = this.state

        if (balance - stakes[gameBox].ante < 0) {
            utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            return
        }

        if (status === GAME && gameBox !== null && boxPlayers && boxPlayers[gameBox] && boxPlayers[gameBox].playerId === playerId && solution !== "HIT" && solution !== "STAND") {

            this.socket.emit("split", gameBox)
            boxStand[gameBox] = [0, 0]

            this.setState({ solution: "STAND", status: WAITING, boxStand, split: false, surrender: false, showTimer: false })

            if (volume) {
                sound.play('sound', 0.2)
            }

            this.updateTimer()

        }

    }

    /* SET INSURANCE */
    setInsurance = (data) => {

        const { balance, stakes, gameBox, total, list } = this.state

        if (gameBox === null) {
            return
        }

        const insurance = stakes[gameBox].ante / 2

        if (data === "yes" && insurance > balance) {
            utils.toggleError(utils.translate("You don't have enough funds"), "error", "nomoney")
            return
        }

        this.socket.emit("insurance", { type: data, box: gameBox })

        this.setState({ status: WAITING, showTimer: false })

        if (data === "yes") {
            this.setState({ insurance, total: total + insurance, list })
        }

        this.updateTimer()

    }


    /* INSURANCE */
    _insurance = () => {

        return (
            <div className="insurance-block">
                <p className="title">INSURANCE?</p>
                <div className="insurance-buttons">
                    <div className="insurance-btn" onClick={() => this.setInsurance("yes")}>
                        <img src={`${env.endpoint}/images/check.png`} alt="check" />
                        <p>YES</p>
                    </div>
                    <div className="insurance-btn red" onClick={() => this.setInsurance("no")}>
                        <img src={`${env.endpoint}/images/close.png`} alt="check" />
                        <p>NO</p>
                    </div>
                </div>
            </div>
        )

    }

    /* Buttons */
    _buttons = () => {

        const { status, split, surrender, playerCards, gameBox, playerBox } = this.state

        const boxCards = playerCards && playerCards[gameBox] ? playerCards[gameBox] : []
        const twoBox = boxCards && boxCards[0] && Array.isArray(boxCards[0])
        const cards = twoBox && Array.isArray(boxCards[playerBox]) ? boxCards[playerBox] : Array.isArray(boxCards) ? boxCards : []

        const doubleBtn = { html: <Double onClick={() => this.double()} key={'double'} />, visible: cards.length === 2 }
        const hitBtn = { html: <Hit onClick={() => this.hit()} key={'hit'} />, visible: true }
        const standBtn = { html: <Stand onClick={() => this.stand()} key={'stand'} />, visible: true }
        const splitBtn = { html: <Split onClick={() => this.split()} key={'split'} />, visible: split }
        const surrenderBtn = { html: <Surrender onClick={() => this.surrender()} key={'surrender'} />, visible: cards.length === 2 && surrender }

        // const buttons = cards.length === 2 && split && surrender ? [[hitBtn, standBtn], [doubleBtn, surrenderBtn, splitBtn]] : [[doubleBtn, hitBtn, standBtn, splitBtn, surrenderBtn]]

        const gameButtons = (window.innerWidth < 600 && window.innerWidth < window.innerHeight) ? [[hitBtn, standBtn, doubleBtn, splitBtn, surrenderBtn]] : [[doubleBtn, hitBtn, standBtn, splitBtn, surrenderBtn]]

        if (status === GAME) {
            return (
                <div className="buttons">
                    {
                        gameButtons.map((array, i) => {
                            return (
                                <div className="buttons-inner" key={`btns-${i}`}>
                                    {
                                        array.map((button, ind) => {
                                            if (button.visible) {
                                                return (
                                                    <div className="button-block" key={`btn-block-${ind}`}>
                                                        {button.html}
                                                    </div>
                                                )
                                            }
                                            return null
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            )
        }

        return null

    }

    _result = () => {
        const { result, boxPlayers, playerId, currency } = this.state

        let totalWin = 0
        let playerResults = []
        result.forEach((boxResult, i) => {
            if (boxResult && boxResult.totalSum && boxPlayers && boxPlayers[i] && boxPlayers[i].playerId === playerId) {
                const sum = boxResult.totalSum ? boxResult.totalSum : 0
                totalWin += sum
                if (totalWin) {
                    playerResults.push({ sum: sum, box: i })
                }
            }
        })

        const style = playerResults.length < 2 ? "mt-result" : ""

        if (totalWin) {
            return (
                <div className={`result ${style}`}>
                    <div className="result-text">
                        <Picture src={`${env.mediapoint}/images/win/money-left.svg`} alt="Left" />
                        <div className="result-win-text">
                            <span>{utils.translate("YOU WIN")}</span>
                            <div className="result-win-price">{utils.getWithCurrency(totalWin, currency)}</div>
                        </div>
                        <Picture src={`${env.mediapoint}/images/win/money-right.svg`} alt="Right" />
                    </div>
                    <div className="results-row">
                        {
                            playerResults.length > 1 && playerResults.map((boxResult, i) => {
                                const boxResultStyle = i % 2 === 0 ? "last-result" : ""
                                return (
                                    <div className={`box-result ${boxResultStyle}`} key={`res-${boxResult.box}`}>
                                        <div className="box-result-text">{utils.translate("HAND") + `-${boxResult.box + 1}`}</div>
                                        <div className="box-result-price">{utils.getWithCurrency(boxResult.sum, currency)}</div>
                                        {i !== 0 ? <div className="box-result-line" /> : null}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )
        }

        return null

    }

    _content = () => {

        const { boxPlayers, playerId, stakes, dealerCards, dealerGame, dealerBJ, status, result, showTimer, innerTimeShow, currentTime, last, total, selected, list, balance, game, currency, volume, chips } = this.state

        const dealerData = { status: status, cards: dealerCards, dealerGame, dealerBJ }

        let i = -1

        if (boxPlayers && Array.isArray(boxPlayers) && boxPlayers.length > 0) {
            i = boxPlayers.findIndex(e => e && e.playerId === playerId)
        }

        const ind = result && Array.isArray(result) ? result.findIndex((e, i) => e && e.totalSum && boxPlayers && boxPlayers[i] && boxPlayers[i].playerId === playerId) : -1

        const resultVisible = ind !== -1

        return (
            <div className="content">

                <div className={`game`}>
                    <DealerCards dealerData={dealerData} />
                    {/* Timer */}
                    {showTimer && !resultVisible ? <Timer status={status} currentTime={currentTime} innerTimeShow={innerTimeShow} hide={() => this.setState({ showTimer: false, status: WAITING })} /> : null}
                    {status !== INSURANCE && !resultVisible ? this._buttons() : null}
                    {status === INSURANCE && !resultVisible ? this._insurance() : null}
                    {resultVisible ? this._result() : null}
                </div>

                <div className={`choice ${(status === "CHOICE" && i !== -1) ? "visible" : "hidden"}`}>
                    <Chips
                        chips={chips}
                        stakes={[...stakes]}
                        boxPlayers={[...boxPlayers]}
                        playerId={playerId}
                        setStakes={data => this.setStakes(data)}
                        total={total}
                        last={[...last]}
                        selected={selected}
                        setSelected={selected => this.setState({ selected })}
                        list={list}
                        setList={list => this.setState({ list })}
                        balance={balance}
                        game={game}
                        currency={currency}
                        volume={volume}
                    />
                </div>
            </div>
        )

    }

    renderCards = (box) => {

        const { status, playerCards, result, blackjack, boxGames, gameBox, playerBox, volume, boxStand } = this.state

        const cards = playerCards && playerCards[box]?.length > 0 ? playerCards[box] : []
        const playerData = {
            box,
            isWin: result && result[box] && result[box].isWin ? result[box].isWin : null,
            selected: box === gameBox,
            cards,
            playerGame: boxGames && boxGames[box] ? boxGames[box] : null,
            status,
            blackjack: blackjack && blackjack[box] ? blackjack[box] : false,
            playerBox,
            volume,
            boxStand: boxStand && boxStand[box] ? boxStand[box] : false
        }

        if (box !== "dealer" && cards && cards.length > 0) {
            return (
                <PlayerCards
                    playerData={playerData}
                />
            )
        }
        return null
    }

    setBackMusic = value => {
        if (value === "play") {
            setTimeout(() => {
                backgroundSound.volume(0.4)
                backgroundSound.play()
            }, 500)
        } else {
            backgroundSound.volume(0)
            backgroundSound.stop()
        }
    }

    /* Get Rules */
    getRules = () => {

        const { language } = this.props

        if (rules[language]) {
            return rules[language]
        }

        return rules["ru"]
    }

    /* Center text */
    _center = () => {

        const { status, boxPlayers, playerId, result, operator } = this.state

        const activeBoxes = boxPlayers.filter(e => e && e.playerId)
        const playerBoxes = boxPlayers.filter(e => e && e.playerId === playerId)
        const ind = result.findIndex((e, i) => e && e.totalSum && boxPlayers && boxPlayers[i] && boxPlayers[i].playerId === playerId)
        const resultVisible = ind !== -1

        const logo = operator !== "makao" ? "cubago.png" : "makao.png"

        let text = null


        if (playerBoxes.length === 0) {
            if (activeBoxes.length === 5) {
                text = "ALL SEATS ARE OCCUPIED"
            } else {
                text = "TAKE A SEAT"
            }
        } else {
            if (status === DEALING) {
                text = "CARDS ARE DEALT"
            }
            //  else if (status === WAITING) {
            //     text = "GAME IN PROCESS"
            // }

        }

        if (resultVisible) {
            return null
        }

        return (
            <div className={`makao`}>
                {
                    text ? <p className="makao-text">{utils.translate(text)}</p> :
                        (status !== GAME && status !== INSURANCE && status !== CHOICE) ?
                            <Picture src={`${env.mediapoint}/images/${logo}`} alt="Makao" />
                            : null
                }

            </div>
        )

    }

    render = () => {

        const { boxPlayers, playerId, stakes, gameBox, list, status, blackjack, result, ppResult, twentyoneResult, crazySevenResult, bustResult, gameInfo, game, balance, total, lastWin, currency, operations, histories, historyHasMore, historyPage, newDevice, closed, isDisconnected, chips, selected, operator, locale, volume, isDemo } = this.state

        const params = { mediapoint: `${env.mediapoint}`, type: "blackjack", lang: locale, operator, isDemo }
        const payout = <Payout game={game} currency={currency} gameJackpot={0} />

        const historyDiv = History

        const historyData = {
            histories,
            historyHasMore,
        }


        if (status === LOADING) {
            return <Preloader operator={operator} />
        }

        if (status === ERROR || newDevice || closed || isDisconnected) {
            return <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} params={params} />
        }

        return (
            <Background historyDiv={historyDiv} params={params} historyData={historyData} payout={payout} gameInfo={gameInfo} rules={this.getRules()} loadMore={() => this.loadHistory(historyPage + 1)} volume={volume} setVolume={volume => this.setState({ volume })} openBalance={() => this.gameAction("openDepositModal")} setBackMusic={value => this.setBackMusic(value)}>
                <div className="app">

                    {/* Game Info */}
                    <GameInfo
                        title={`BLACKJACK`}
                        game={game}
                        currency={currency}
                        payout={payout}
                        params={params}
                        close={() => this.gameAction("closeGame")}
                    />

                    {/* Balance */}
                    <Balance
                        balance={balance}
                        total={total}
                        lastWin={lastWin}
                        currency={currency}
                        params={params}
                        openBalance={() => this.gameAction("openDepositModal")}
                    />

                    {/* Transactions */}
                    <Transactions
                        info={gameInfo}
                        operations={operations}
                        currency={currency}
                        params={params}
                    />

                    <Rates
                        status={status}
                        boxPlayers={boxPlayers}
                        playerId={playerId}
                        gameBox={gameBox}
                        setStakes={data => this.setStakes(data)}
                        boxJoin={box => this.boxJoin(box)}
                        boxLeft={box => this.boxLeft(box)}
                        stakes={stakes}
                        blackjack={blackjack}
                        result={result}
                        ppResult={ppResult}
                        twentyoneResult={twentyoneResult}
                        crazySevenResult={crazySevenResult}
                        bustResult={bustResult}
                        chips={chips}
                        selected={selected}
                        balance={balance}
                        game={game}
                        list={list}
                        setList={list => this.setState({ list })}
                        renderCards={box => this.renderCards(box)}
                    />

                    {/* Content */}
                    {this._content()}

                    {this._center()}

                    <div className="back-outer">
                        <div className="background" />
                        <div className="glass" />
                        <div className="shadow" />
                    </div>

                    <Notification />

                    <Internet url={imgUrl} setInternetSpeed={data => this.checkInternetSpeed(data)} />

                </div>
            </Background>
        )

    }

}

const mapStateToProps = state => {
    return {
        language: state.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLanguage: data => dispatch({ type: 'SET_LANGUAGE', payload: data })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)